module.exports = __webpack_public_path__ + "static/media/graffiti_virtual_1.550d9f71.jpg";